<template>
  <v-textarea
    v-model="text"
    type='text'
    :label="label"
    :error-messages="errors"
    :hide-details="!v.$error"
    outlined
    :disabled="disabled"
    rows="4"
  ></v-textarea>
</template>

<script>
export default {
  props: [
    'value',
    'v',
    'errors',
    'label',
    'disabled',
  ],

  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/TextareaComponent.vue